import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { GdpAccessService } from '../services/gdp-access.service';

/**
 * Protege las rutas /gdp/**: espera a /gdp/me (cacheado o en vuelo) y
 * redirige a /dashboard si la cuenta no tiene acceso GDP activo.
 */
export const gdpAccessGuard: CanActivateFn = () => {
  const gdpAccess = inject(GdpAccessService);
  const router = inject(Router);

  return gdpAccess.ensureLoaded().pipe(
    map(access => (access.hasAccess ? true : router.createUrlTree(['/dashboard'])))
  );
};

/**
 * Protege las rutas de administración de GDP (p. ej. /gdp/suggestions):
 * igual que gdpAccessGuard pero exige además accessType ADMIN, redirigiendo
 * a la home de GDP. Solo gating de UI: el backend impone los permisos reales.
 */
export const gdpAdminGuard: CanActivateFn = () => {
  const gdpAccess = inject(GdpAccessService);
  const router = inject(Router);

  return gdpAccess.ensureLoaded().pipe(
    map(access =>
      access.hasAccess && access.accessType === 'ADMIN' ? true : router.createUrlTree(['/gdp'])
    )
  );
};
